import { render } from "./InvoiceTransmissionHeader.vue?vue&type=template&id=6d188276"
import script from "./InvoiceTransmissionHeader.vue?vue&type=script&lang=js"
export * from "./InvoiceTransmissionHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__